module.exports = __webpack_public_path__ + "images/ae2711611adcf1c6ed519ff79ea91101.svg";